import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@auth0/auth0-spa-js';

interface AuthState {
  token?: string;
  user?: User;
  hasApplicationAccess: boolean;
}

const initAuthState: AuthState = {
    hasApplicationAccess: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initAuthState,
  reducers: {
    login: (state, action: PayloadAction<AuthState | undefined>) => {
      state.user = action.payload?.user;
      state.token = action.payload?.token;
      state.hasApplicationAccess = action.payload === undefined ? false : action.payload?.hasApplicationAccess;
    },
    logout: (state) => {
      state.token = '';
      state.hasApplicationAccess = false;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
